<template>
	<div>
		<div v-if="show==true" class="gray">
			<div class="dialog">
				<div style="display:inline-block; width:100%;">
					<p class="title">{{title}}</p>
					<p class="cancel" v-on:click="cancel()"><font-awesome-icon icon="times" /></p>
				</div>
				<hr/>
				<div style="display:inline-block; width:100%;">
					<div class="field">
						<label class="paragraph" for="quantity">Quantity</label>
						<input id="quantity" v-model="quantity"></input>
					</div>
					<div class="field">
						<label class="paragraph" for="weight">Weight</label>
						<input id="weight" v-model="weight"></input>
					</div>
					<div v-if="perms.includes('93')" class="field">
						<label class="paragraph" for="employee">Employee</label>
			            <autocomplete
						id="employee"
			            v-model="employee"
			            :type=16
						v-on:input=setData
						style="display:inline; float:right; width:70%;"
			            />
					</div>
					<div v-else class="field">
						<label class="paragraph" for="employeeDisabled">Employee</label>
						<input id="employeeDisabled" v-model="employee" disabled></input>
					</div>
					<div v-if="isIn==true" class="field">
						<label class="paragraph" for="box">Box</label>
			            <input id="box" v-model="box"></input>
					</div>
					<div class="field">
						<label class="paragraph" for="joborder">Job Order</label>
						<autocomplete
						id="joborder"
						v-model="joborder"
						:type=58
						v-on:input=setJoborderData
						style="display:inline; float:right; width:70%;"
						/>
					</div>
					<div class="field">
						<label class="paragraph" for="notes">Notes</label>
						<textarea id="notes" v-model="notes"></textarea>
					</div>
				</div>
				<hr/>
				<div style="display:inline-block; width:100%;">
					<button class="buttons" v-on:click="button(button_name)">{{buttonname}}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		show: Boolean,
		isIn: Boolean,
		autoClose: {
			type: Boolean,
			required:false,
			default:true,
		},
		itemId: Number,
    },
	data() {
		return {
			perms:[],
			pageid:PAGES.CHECK_ITEM_DATA_PAGE,
			title:"",
			buttonname:"",
			employee:"",
			quantity:0,
			weight:0,
			box:"",
			joborder:"",
			notes:"",
		}
	},
	async created () {
		this.perms = api.getPerms();
		this.search();
	},
	mounted(){
		this.setText()
	},
	methods:{
		setText(){
			if(this.isIn==true){
				this.title = "Check In Item "+this.itemId
				this.buttonname = "Check In"
			}else{
				this.title = "Check Out Item "+this.itemId
				this.buttonname = "Check Out"
			}

			this.search()
		},
		async button(buttonname){

			api.postData(
                {
                    type:"insert",
                    data:{
						pageid:this.pageid,
						data:[
							this.isIn,
							this.itemId,
							this.quantity,
							this.weight,
							this.employee,
							this.box,
							this.notes,
							this.joborder,
						]
					}
                }
            ).then((res) => {
				this.$emit('dialogue', this.itemId);
				if(this.autoClose){
					this.cancel();
				}
	        })
		},
		async cancel(){
			this.$emit('cancel');
		},
		async search (){

			if(this.itemId=="" || this.itemId==undefined){
				return
			}

			api.postData(
                {
                    type:"search",
                    data:{
						pageid:this.pageid,
						itemId:this.itemId
					}
                }
            ).then((res) => {
				if(res.data.data!=null && res.data.data.column_data!=null){
					this.quantity = res.data.data.column_data[0][0];
					this.weight = res.data.data.column_data[0][1];
					this.employee = res.data.data.column_data[0][2];
					this.box = res.data.data.column_data[0][3];
					this.joborder = res.data.data.column_data[0][4];
				}

				if(this.quantity == ""){
					this.quantity = 1;
				}
	        })
		},
		setData(data){
			this.value = data
		},
		setBoxData(data){
			this.box = data
		},
		setJoborderData(data){
			this.joborder = data
		},
	},
	watch:{
		isIn(){
			this.setText()
		},
		itemId(){
			this.setText()
		},
		quantity(){
			if(isNaN(this.quantity)){
				this.quantity = 0;
			}else if(this.quantity!=''){
				this.quantity = parseInt(this.quantity);
			}

		}
	}
}
</script>

<style scoped>

.dialog{
	position:fixed;
	background-color:white;
	left: 50%;
	top:20vh;
	min-width:800px;
	transform: translateX(-50%);
	padding:15px;
	border:1px solid black;
	border-radius: 5px;
	box-shadow: 2px 2px;
}

.title{
	font-size: 40px;
	font-weight: bold;
	float:left;
	margin:0px;
}

.cancel{
	float:right;
	width:30px;
	text-align: center;
	font-size:24px;
}
.cancel:hover{
	color:#5c5e70;
}

.paragraph{
	font-size:22px;
	margin:0px;
	display:inline;
}

.field{
	display:block;
}

.field input, textarea{
	width:70%;
	float:right;
}

.buttons{
	float:right;
	font-size:18px;
}

.gray {
	display: absolute;
	position: fixed;
	z-index: 2;
	padding-top: 100px;
	left: 0;
	top: 0;
	width:100%;
	height:100%;
	overflow:auto;
	background-color: rgba(0,0,0,0.5);
}

</style>

<!--
EXAMPLE

<dialogue
	:title="'Delete'"
	:paragraph="'Are you sure you want to delete Techdoc '+term+'?'"
	:button_names="['Delete']"
	:show="delete_dialogue"
	v-on:dialogue="deleteTechdoc"
	v-on:cancel="cancelDelete"
></dialogue>

data{
	delete_dialogue:false,
}

async cancelDelete(){
	this.delete_dialogue=false;
},
async deleteTechdocDialogue(optional_buttonname){
	this.delete_dialogue=true;
},

-->



// WEBPACK FOOTER //
// src/layouts/checkitem.vue